import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { string, bool, arrayOf } from "prop-types";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import { textFormat } from "utils/Utils";

const style = () => ({
  selectInput: {
    '& .Mui-disabled':{
      color:brandTheme.fieldColor,
      backgroundColor:brandTheme.disabled,
    },
    "& .MuiSelect-root": {
      padding: "10px",
    },
    "& .MuiFormLabel-root": {
      fontSize: "0.875rem",
      top: "-10px",
      left: "0.875rem",
      color: brandTheme.black,
    },
    "& .MuiInputBase-root.Mui-disabled":{
      backgroundColor: brandTheme.disabled,
     },
    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.black,
      top: "-7px",
      left: "14px",
      fontSize: "1rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
  },
  errorInput: {
    "& .MuiFormLabel-root": {
      color: brandTheme.errorColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.errorColor,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.errorColor,
    },
  },
});

const CustomSelectNew = ({
  label,
  id,
  required,
  classes,
  data,
  value,
  setState,
  setError,
  error,
  type,
  index,
  disabled,
  groupindex,
  disabledOptions = [] 
}) => {
  return (
    <FormControl
      fullWidth
      className={
        error
          ? `${classes.errorInput} ${classes.selectInput}`
          : classes.selectInput
      }
    >
      <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel>
      <Select
        size="small"
        required={required}
        variant="outlined"
        labelId="demo-simple-select-filled-label"
        id={id}
        value={value}
        disabled={disabled ? true : false}
        label={label}
        onChange={(event) => {
          if(type === "newSchemeCharge"){
            setState(event.target.value, index, label )
          }else if(type === "newSchemeChargeName"){
            setState(event.target.value, index, label )
          }else if(type === "newSchemeChargeType"){
            setState(event.target.value, index, label )
          }else if(type === "packetNumbers" || type === "partnerName"  || type === "bool" ||type === "productType" || type === "partnerCode" || type === "partnerDealCode" || type === "TYPE" || type === "roleNew" || type === "designation" || type === "nameFormat" || type === "value"){
            setState(event.target.value)
          }
          else if(type === "chargeDetailsNature"){
            setState(event.target.value, groupindex, type , index)
          }
          else{
            setState(textFormat(event.target.value));
            setError(false);
          }
        }}
        
      >
        {data &&
          data.map((item, index) => {
           
            let selectValue = "";
            switch (type) {
              case "role":
                selectValue = item.role;
                break;
              case "roleNew":
                selectValue = item.role;
                break;
              case "parentcode":
                selectValue = item?.code;
                break;
              case "channel":
                selectValue = item?.channel;
                break;
                case "hierarchyCode":
                  selectValue = item?.code;
                break;
                case "newSchemeChargeName":
                  selectValue = item?.name;
                break;
                case "newSchemeChargeType":
                  selectValue = item?.type;
                break;
                case "packetNumbers":
                  selectValue = item;
                break;
                case "nameFormat":
                  selectValue = item;
                break;
                case "bool":
                  selectValue = item.code;
                  break;
                case "designation":
                  selectValue= item.designation;
                  break;
                case "partnerCode":
                  selectValue= item?.partnerCode;
                  break;
                  case "partnerDealCode":
                    selectValue=item?.code;
                  break;
                  case "partnerName":
                    selectValue = item.code;
                  break;
                  case "value":
                    selectValue = item.id;
                  break;
              default:
                selectValue = item.code;
            }

            let selectName = "";
            switch (type) {
              case "parentcode":
                selectName = item?.code;
                break;
                case "role":
                  selectName = item?.name?.toLowerCase()?.replace(/role|_/g, " ").replace(/\s+/g, " ").trim();
                  break;
              case "channel":
                selectName = item?.channel;
                break;
                case "hierarchyCode":
                  selectName = item?.code;
                break;
                case "newSchemeChargeName":
                  selectName = item?.name?.replace(/_/g, " ");
                break;
                case "newSchemeChargeType":
                  selectName = item?.type?.replace(/_/g, " ");
                break;
                case "nameFormat":
                  selectName = item?.replace(/_/g, " ");
                break;
                case "packetNumbers":
                  selectName = item;
                break;
                case "bool":
                  selectName = item.name;
                  break;
                  case "designation":
                    selectName= item.designation;
                    break;
                      case "partnerCode":
                  selectName= item?.partnerCode;
                  break;
                        case "partnerDealCode":
                    selectName=item?.code;
                    break;
                  case "partnerName":
                      selectName = item.name;
                      break;
                  case "value":
                      selectName = item.name;
                      break;
                  default:
                    selectName = item?.name?.replace(/_/g, " ");
            }
            return (
              <MenuItem key={index} value={(type === "TYPE" || type === "bool" || type === "packetNumbers"  || type === "newSchemeCharge" || type === "newSchemeChargeName" || type=== "newSchemeChargeType" || type === "chargeDetailsNature" || type === "roleNew" || type === "designation"|| type==="partnerName" || type === "nameFormat" || type==="partnerCode" || type === "partnerDealCode" || type === "value") ? selectValue : textFormat(selectValue)} disabled={disabledOptions.includes(selectValue)}>
               {(type === "TYPE" || type === "packetNumbers" || type === "newSchemeCharge" || type === "hierarchyCode" || type === "newSchemeChargeName" || type === "chargeDetailsNature" || type === "roleNew" || type === "designation" || type==="partnerCode" || type==="partnerName" ||type === "partnerDealCode" ) ? selectName : textFormat(selectName)}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

CustomSelectNew.propTypes = {
  label: string.isRequired,
  id: string,
  required: bool,
  disabledOptions: arrayOf(string), 
};
CustomSelectNew.defaultProps = {
  label: string.isRequired,
  id: "text-field",
  required: false,
  disabledOptions: [],
};
export default withStyles(style)(CustomSelectNew);